import request from '@/router/axios'

const baseCategoryUrl = '/sg-user-service/v1/tenement'

export function categoryList (isLogin, lang) {
  return request({
    url: baseCategoryUrl + '/tree',
    method: 'get',
    params: {
      lang: lang || "en",
      isLogin: isLogin
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/exam/main.js